import LinkComp from 'components/atoms/LinkComp';
import { useCountdownBars } from 'hooks/useCountdownBars';
import { memo, useEffect } from 'react';
import { ImageFallbackBanner } from 'utils/ImageFallback';
import gtag from 'utils/gtag';
import { ENUM_COUNTDOWN_BAR_IMAGE_TYPE, ENUM_COUNTDOWN_BAR_TYPE } from './header';
import styles from './styles.module.css';

function CountDownBar({ type = ENUM_COUNTDOWN_BAR_TYPE.WEBSITE }) {
  const { countdownBarList } = useCountdownBars();

  // Chỉ lấy countdown bar cài cho vị trí này; bar cũ không có type coi như WEBSITE
  const countdownBarByType = countdownBarList.filter((cd) => (cd?.type || ENUM_COUNTDOWN_BAR_TYPE.WEBSITE) === type);
  const countdownBarHalf = countdownBarByType.filter((cd) => cd?.imageType === ENUM_COUNTDOWN_BAR_IMAGE_TYPE.HALF);
  const countdownBarFull = countdownBarByType.filter((cd) => cd?.imageType === ENUM_COUNTDOWN_BAR_IMAGE_TYPE.FULL);

  // tracking impresssion
  useEffect(() => {
    if (countdownBarHalf?.length >= 2 || countdownBarFull?.length > 0) {
      gtag.displayCountDownBar();
    }
  }, [countdownBarHalf, countdownBarFull]);

  if (countdownBarHalf?.length >= 2) {
    return (
      <div className={styles.countdownBarHalfWrapper}>
        <div className={styles.countdownBarHalf}>
          {countdownBarHalf
            .slice(0, 2)
            .reverse()
            .map((cd) => (
              <div key={cd.code} className={styles.countdownBarHalfLimit}>
                <LinkComp href={cd.url} style={{ padding: 0 }} onClick={() => gtag.clickCountdownbar(cd)}>
                  <ImageFallbackBanner
                    isGIF
                    src={cd.imageUrl}
                    fallbackSrc={cd.imageUrl}
                    objectFit="contain"
                    quality={100}
                    layout="fill"
                    width={2100}
                    alt={cd.name}
                    priority
                  />
                </LinkComp>
              </div>
            ))}
        </div>
      </div>
    );
  }

  if (countdownBarFull?.length > 0) {
    const cd = countdownBarFull[0];
    return (
      <LinkComp href={cd?.url} style={{ padding: 0 }} onClick={() => gtag.clickCountdownbar(cd)}>
        <div className={styles.countdownBarFullWrapper} style={{ backgroundColor: cd?.backgroundColor || '#fff' }}>
          <ImageFallbackBanner isGIF src={cd.imageUrl} fallbackSrc={cd.imageUrl} layout="fill" width={2100} alt={cd.name} priority />
        </div>
      </LinkComp>
    );
  }

  return <></>;
}

export default memo(CountDownBar);
